import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'

import { CMSState, Url } from '../types.gen'
import { link, getClassName, linkWrapper } from '../utils.gen'
import { toRelativeUrl } from '../../../../helpers'
import { ButtonData } from '../../../wordpress/types_and_parser/extra_types.mod'
import { urlIsExternal } from '../../../../utils'

export type LinkBlockProps = {
  title: string
  intro?: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  items: LinkProps[]
}

export type LinkProps = { key?: string; title: string; url: Url; target?: '_blank' | '_self' }

export type LinkBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  list_classname: string
  item_classname: string
  link_classname: string
}>

export function LinkBlock<customBlockData, extra_images>(
  props: LinkBlockProps,
  options?: {
    style?: LinkBlockStyle
    key?: string
  }
): IOWidget<CMSState<customBlockData, extra_images, never>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (s: CMSState<customBlockData, extra_images, never>) =>
    mk_widget({
      run: _ => (
        <section
          className={getClassName(options, 'block_classname', 'container')}
          key={options && options.key ? options.key : 'link-block'}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            <header className={getClassName(options, 'header_classname', '')}>
              {props.title && <h2 className={getClassName(options, 'title_classname', 'mb-3')}>{props.title}</h2>}
              {props.intro && <div className={getClassName(options, 'intro_classname', '')} dangerouslySetInnerHTML={{__html: props.intro}} />}
            </header>
            {(props.primary_button || props.secondary_button) && (
              <ul className="download__buttons">
                {props.primary_button && (
                  <li className="download__button">
                    {link(linkWrapper({title: props.primary_button.text, url: props.primary_button.url}),
                      { classname: 'btn btn--primary' },
                      props.primary_button.text
                    )}
                  </li>
                )}
                {props.secondary_button && (
                  <li className="download__button">
                    {link(linkWrapper({title: props.secondary_button.text, url: props.secondary_button.url}),
                      { classname: 'btn btn--secondary' },
                      props.secondary_button.text
                    )}
                  </li>
                )}
              </ul>
          )}
            <div className={getClassName(options, 'content_classname', '')}>
              <ul className={getClassName(options, 'list_classname', 'list-unstyled mb-0 row')}>
                {props.items.map((l, _) => (
                  <li className={getClassName(options, 'item_classname', 'col-md-6')} key={l.key}>
                    {l.title && l.url
                      ? link(linkWrapper({title: l.title, url: l.url}),
                          {
                            classname: getClassName(
                              options,
                              'link_classname',
                              'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                            )
                          },
                          `${l.title}`
                        )
                      : null}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      )
    })
}
